import React, {Component} from 'react';
import { adminloadTP, getAPI, setRound, AuthenticatedUser, putToast, stopTimer } from "../../../api";
import Modal from 'react-responsive-modal';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'
import Moment from 'react-moment';
import moment from 'moment';
import ReactHtmlParser from "react-html-parser";
import {CSVLink} from "react-csv";

class TournamentAdminPostings extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onRoundSet = this.onRoundSet.bind(this);
        this.getTdProps = this.getTdProps.bind(this);
        this.buildBuiltCSV = this.buildBuiltCSV.bind(this);
        this.buildSchedCSV = this.buildSchedCSV.bind(this);

        this.state = {
            loading: true,
            open: false,
            user: user,
            selectedRound: null,
            tData: {},
            pid: params.pid
        }

    }
    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            adminloadTP('none', 'ef', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ tData: d2.tournamentPage, loading: false}); 
                    this.getBallotAnalysis(this.state.pid)                  
                    this.getBuiltAnalysis(this.state.pid)                  
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row && column.id !== "delete") {
            return {
                onClick: () => { 
                    this.setState({ selectedRound: rowInfo.original})
                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }
          
    calcRegisteredCompetitors() {
        return this.state.tData.events.reduce((a,b) => a + (b.competitors.filter(x=>x.isRegistered).length || 0),0);
    }
  
    getApprovable(state) {
        var approvable = true;
/*
        if (state) {

            if (approvable) {
                const emails = state.tEventCompetitor.judgeEmails.split(",").map(x=>x.trim()).filter(Boolean);

                var valid = true;
                var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                
                for (var i = 0; i < emails.length; i++) {
                    if( emails[i] == "" || ! regex.test(emails[i])){
                        valid = false;
                    }
                }
                approvable = approvable && valid;
            }

            approvable = approvable && state.tEventCompetitorEvent.isRegistered;
        }
*/
        return approvable;
    }
    
    setApprovable(state) {
        const btn = document.getElementById("approveButton");

        btn.disabled = !this.getApprovable(state);
    }
    
    sequencer() {
        const commands = ['building', 'released', 'posted', 'fakeballots'];
        var that=this;
        setTimeout(function () {
            that.onRoundSet(commands[0])
            setTimeout(function () {
                that.onRoundSet(commands[1])
                setTimeout(function () {
                    that.onRoundSet(commands[2])
                    setTimeout(function () {
                        that.onRoundSet(commands[3])
                        setTimeout(function () {
                            that.getBallotAnalysis(that.state.pid)
                        }, 500);
                    }, 500);
                }, 500);
            }, 500);
        }, 500);
    }

    wait = (ms) => {
        var start = new Date().getTime();
        var end = start;
        while(end < start + ms) {
          end = new Date().getTime();
       }
     }

    onRoundSet = (newState) => {
        // TODO: enable for testing
        //if (newState === 'fakeballots') return;
        
        setRound(this.state.tData._id, newState).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
                putToast.error(d2.error);
            } else {
                putToast.success(d2.message);

                this.setState({ tData: d2.tournamentPage});  
                if (newState === 'building') this.getBuiltAnalysis(this.state.pid);                
                if (newState === 'fakeballots') this.getBallotAnalysis(this.state.pid);                
            }
        });
    };

    getBuiltAnalysis(pid) {
        getAPI(`built/analyze/${pid}`)
        .then(result => {
            this.setState({ builtData: result.data, schedule: result.schedule})
        })
    }

    buildBuiltCSV() {
        const currentRecords = this.reactTableBuilt.getResolvedState().sortedData;
        var data_to_download = []
        for (var index = 0; index < currentRecords.length; index++) {
            let record_to_download = {}
            for(var colIndex = 0; colIndex < this.buildColumns.length ; colIndex ++) {
                if(colIndex === 2) {
                    var value = currentRecords[index][this.buildColumns[colIndex].accessor];
                    value = value.substring('<a target=_blank" rel="noopener noreferrer" href='.length+1);
                    value = value.substring(0,value.length - 4)
                    var i = value.indexOf(">");
                    var roomNumber = value.substring(i+1);
                    value = value.substring(0,i);
                    record_to_download[this.buildColumns[colIndex].Header] = `${roomNumber}: ${value}`;
                } else record_to_download[this.buildColumns[colIndex].Header] = currentRecords[index][this.buildColumns[colIndex].accessor]
            }
            data_to_download.push(record_to_download)
        }

        this.setState({ dataToDownload: data_to_download}, () => {
            // click the CSVLink component to trigger the CSV download
            this.csvLinkBuilt.link.click()
        })       
    }


    buildSchedCSV() {
        const currentRecords = this.reactTableSched.getResolvedState().sortedData;
        var data_to_download = []
        for (var index = 0; index < currentRecords.length; index++) {
            let record_to_download = {}
            for(var colIndex = 0; colIndex < this.schedColumns.length ; colIndex ++) {
                if(colIndex === 3) {
                    var value = moment(currentRecords[index][this.schedColumns[colIndex].accessor]).format('LT')
                    record_to_download[this.schedColumns[colIndex].Header] = value;
                } else record_to_download[this.schedColumns[colIndex].Header] = currentRecords[index][this.schedColumns[colIndex].accessor]
            }
            data_to_download.push(record_to_download)
        }

        this.setState({ dataToDownload: data_to_download}, () => {
            // click the CSVLink component to trigger the CSV download
            this.csvLinkSched.link.click()
        })       
    }

    getBallotAnalysis(pid) {
        getAPI(`ballot/analyze/${pid}`)
        .then(result => {
            this.setState({ ballotData: result.data})
        })
    }





    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, open, user } = this.state;
            this.buildColumns = [
                { Header: 'Round', accessor: 'round', maxWidth: 150},
                { Header: 'Event', accessor: 'event', maxWidth: 250},
                { Header: 'Room', accessor: 'room', maxWidth: 150,                
                Cell:  (props) => { return ReactHtmlParser(props.value)}}            
            ]
            if (this.state.builtData && this.state.builtData.find(x=>x.B)) {
                this.buildColumns.push({ Header: 'Aff/Gov/Pet', accessor: 'A', maxWidth: 220 });
                this.buildColumns.push({ Header: 'Neg/Opp/Res', accessor: 'B', maxWidth: 220 });
            } else {
                this.buildColumns.push({ Header: 'Speakers', accessor: 'A', maxWidth: 440 });
            }
            this.buildColumns.push({ Header: 'Judges', accessor: 'jud' })
            

            this.schedColumns=[{
                Header: 'Competitor',
                accessor: 'competitor',
            },{
                Header: 'Event',
                accessor: 'event',
            },{
                Header: 'Room',
                accessor: 'room',
            },{
                Header: 'TimeSlot',
                accessor: 'timeSlot', 
                Cell:  (props) => {                                            
                    return (
                       <span >{moment(props.value).format('LT')}</span>
                    )},
            }]  

            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Posting Administration - ${user.displayname}`} title3=""
                bcTitle="Posting" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                    {name: "Administration", url: `/tournament/admin/${tData._id}`}
                ]}
            >                
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12"> 
                                <button type="button" className="btn btn-danger" onClick={() => this.onRoundSet('purge')} style={{margin: "6px"}}>Purge</button> 
                                <button type="button" className="btn btn-danger" onClick={() => this.onRoundSet('fakeballots')} style={{margin: "6px"}}>Fake Ballots</button>

                                <button type="button" className="btn btn-primary pull-right" onClick={() => this.onRoundSet('posted')} style={{margin: "6px"}}>Post</button>
                                <button type="button" className="btn btn-primary pull-right" onClick={() => this.onRoundSet('released')} style={{margin: "6px"}}>Release</button>  
                                <button type="button" className="btn btn-primary pull-right" onClick={() => this.onRoundSet('building')} style={{margin: "6px"}}>Build</button>  
                                <button type="button" className="btn btn-primary pull-right" onClick={() => this.onRoundSet('open')} style={{margin: "6px"}}>Open</button> 
                                <button type="button" className="btn btn-primary pull-right" onClick={() => this.onRoundSet('announcing')} style={{margin: "6px"}}>Announce</button>  
                            </div>
                        </div>            
                        <div className="row">
                            <div className="col-sm-12">
                                <ReactTable
                                    data={tData.rounds}
                                    columns={[{
                                        Header: 'Announcing?',
                                        accessor: 'isAnnouncing',
                                        style: { textAlign: 'center'},
                                        maxWidth: 120,                                   
                                        Cell: (row) => {
                                            return (
                                               <input
                                                   type='checkbox'
                                                   id={'isa'+row.original._id}
                                                   checked={row.original.isAnnouncing}
                                                   style={{zoom: "1.2", width: "20px", height: "20px"}}
                                               />                                          
                                            )}
                                    },{
                                        Header: 'Round',
                                        accessor: 'title',
                                    },{
                                        Header: 'Status',
                                        accessor: 'status',
                                    },{
                                        Header: 'Start',
                                        accessor: 'startDate', 
                                        Cell: (prop) => (
                                            <span><Moment format="lll">{prop.value}</Moment></span>
                                        )
                                    },{
                                        Header: 'Stop',
                                        accessor: 'stopDate', 
                                        Cell: (prop) => (
                                            <span><Moment format="lll">{prop.value}</Moment></span>
                                        )                                    
                                    },{
                                        Header: 'Due',
                                        accessor: 'dueDate',
                                        Cell: (prop) => (
                                            <span><Moment format="lll">{prop.value}</Moment></span>
                                        )                                    
                                    }]}    

                                    pageSize={(tData.rounds.length > 20) ? 20 : tData.rounds.length}
                                    showPagination={(tData.rounds.length > 20)}                    
                                    defaultPageSize={20}
                                    getTdProps={this.getTdProps}                                                                                                                                                                                                                                                        
                                />
                            </div>
                        </div>
                        {this.state.builtData &&                        
                        <div className="row">
                            <div className="col-sm-12">
                            <hr />
                                <h3 style={{marginLeft: "20px", display: "inline"}}>Build Results</h3>
                                <CSVLink style={{marginLeft: "20px", display: "inline"}}
                                    data={this.state.dataToDownload ? this.state.dataToDownload : ""}
                                    filename={`build_${moment().format('YYYYMMDD_HHmmss')}.csv`}
                                    className="hidden"
                                    ref={(r) => this.csvLinkBuilt = r}
                                    target="_blank"
                                />
                                <button style={{marginLeft: "20px", marginBottom: "6px", display: "inline"}} type="button" className="btn btn-primary" onClick={this.buildBuiltCSV}>Download</button>
                                <ReactTable ref={(r) => this.reactTableBuilt = r}
                                    filterable
                                    defaultFilterMethod={ (filter, row, column) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                    }}
                                    data={this.state.builtData}
                                    columns={this.buildColumns}                                        
                                    pageSize={(this.state.builtData.length > 20) ? 20 : this.state.builtData.length}
                                    showPagination={(this.state.builtData.length > 20)}                    
                                    defaultPageSize={20}                                         
                                />
                            </div>
                        </div>                                            
                        }
                        {this.state.ballotData &&                        
                        <div className="row">
                            <div className="col-sm-12">
                            <hr />
                                <h3>Team Results</h3>
                                    <ReactTable
                                    filterable
                                    defaultFilterMethod={ (filter, row, column) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                    }}
                                    data={this.state.ballotData}
                                    columns={[{
                                        Header: 'Event',
                                        accessor: 'event',
                                        maxWidth: 250,                                   
                                    },{
                                        Header: 'Team',
                                        accessor: 'displayname',
                                        maxWidth: 350,
                                    },{
                                        Header: 'Role',
                                        accessor: 'roles',
                                        maxWidth: 60,                                   
                                    },{
                                        Header: 'Rpt',
                                        accessor: 'repeats',
                                        maxWidth: 60,                                   
                                    },{
                                        Header: 'SOF',
                                        accessor: 'sof',                                        
                                        maxWidth: 60,                                   
                                    },{
                                        Header: 'P Rank',
                                        accessor: 'prelimRank',                                        
                                        maxWidth: 70,                                   
                                    },{
                                        Header: 'P Wins',
                                        accessor: 'prelimWins',
                                        maxWidth: 110,                                   
                                    },{
                                        Header: 'P Points',
                                        accessor: 'prelimPoints',
                                        maxWidth: 110,                                   
                                    },{
                                        Header: 'E Rank',
                                        accessor: 'elimRank',                                        
                                        maxWidth: 70,                                   
                                    },{
                                        Header: 'E Wins',
                                        accessor: 'elimWins',
                                        maxWidth: 110,                                   
                                    },{
                                        Header: 'E Points',
                                        accessor: 'elimPoints',
                                        maxWidth: 110,                                   
                                    }]}                                        
                                    defaultPageSize={32}
                                    showPagination={true}  
                                    getTdProps={this.getTdProps}                                                                                                     
                                />
                            </div>
                        </div>                                            
                        }                        
                        {this.state.schedule &&                        
                            <div className="row">
                                <div className="col-sm-12">
                                    <hr />
                                    <h3 style={{marginLeft: "20px", display: "inline"}}>Schedule</h3>
                                    <CSVLink style={{marginLeft: "20px", display: "inline"}}
                                        data={this.state.dataToDownload ? this.state.dataToDownload : ""}
                                        filename={`schedule_${moment().format('YYYYMMDD_HHmmss')}.csv`}
                                        className="hidden"
                                        ref={(r) => this.csvLinkSched = r}
                                        target="_blank"
                                    />
                                    <button style={{marginLeft: "20px", marginBottom: "6px", display: "inline"}} type="button" className="btn btn-primary" onClick={this.buildSchedCSV}>Download</button>
                                    <ReactTable ref={(r) => this.reactTableSched = r}
                                        filterable
                                        defaultFilterMethod={ (filter, row, column) => {
                                            const id = filter.pivotId || filter.id
                                            return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                        }}
                                        data={this.state.schedule}
                                        columns={this.schedColumns}                                        
                                        pageSize={(this.state.schedule.length > 10) ? 10 : this.state.schedule.length}
                                        showPagination={(this.state.schedule.length > 10)}                    
                                        defaultPageSize={10}                                         
                                    />
                                </div>
                            </div>                                            
                        }                          
                        
                    </div> 

                    <Modal open={open} onClose={this.onCloseEventRegistrationModal} >
                        <div className="modal-header">
                            <h5 className="modal-title f-w-600" id="exampleModalLabel2">Posting Control`</h5>
                        </div>
                        <div className="modal-body">
                            <div className="container">
                                <div className="card">
                                    <div className="card-body">
                                    </div>
                                </div>        
                            </div>
                        </div>
                        <div className="modal-footer">              
                        <button type="button" className="btn btn-primary" onClick={this.onCancelEventRegistrationModal}>Cancel</button>
                        <button id="approveButton" type="button" className="btn btn-primary" onClick={this.onCloseEventRegistrationModal} disabled={!this.getApprovable(this.state)} >Approve</button>
                        </div>
                    </Modal>
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdminPostings;